import React from 'react'
import Register from '../../components/Register/Register';
import './SignupPage.css';
const SignupPage = () => {
  return (
    <div className='signup'>
      <Register />
      
    </div>
  );
}

export default SignupPage
